import { Dispatch } from 'redux'

import * as Api from 'redux/api/DashboardFolders'

import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from '../useThunkActions'

import * as actions from './actions'
import type {
  TCreateDashboardFolderRequest,
  TUpdateDashboardFolderRequest
} from '@homepal/api-contract'

function tryCreateDashboardFolder(body: TCreateDashboardFolderRequest) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    Api.create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderCreatedFailed))
      })
  }
}

export function tryGetAllDashboardFolders(dispatch: Dispatch) {
  dispatch(actions.getAll())

  Api.getAll()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data.data))
    })
    .catch(() => {
      dispatch(actions.getAllFailed())
    })
}

function tryUpdateDashboardFolder(
  id: string,
  body: TUpdateDashboardFolderRequest
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderUpdated))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderUpdatedFailed))
      })
  }
}

function tryDeleteDashboardFolder(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    Api.destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderDeleted))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FolderDeletedFailed))
      })
  }
}

export const useDashboardFolderActions = () => {
  return {
    tryGetAllDashboardFolders: useThunkActions(tryGetAllDashboardFolders),
    tryCreateDashboardFolder: useThunkActions(tryCreateDashboardFolder),
    tryUpdateDashboardFolder: useThunkActions(tryUpdateDashboardFolder),
    tryDeleteDashboardFolder: useThunkActions(tryDeleteDashboardFolder)
  }
}
